export enum LCAppId {
	main = 0,
	recorderLoops = 1,
	bandLoops = 2,
	easyLoops = 3
}

export function getLcAppNameById(appId:LCAppId):string {
	switch (appId){
		case LCAppId.main: {
			return "ScoreLoops";
		}
		case LCAppId.recorderLoops: {
			return "RecorderLoops";
		}
		case LCAppId.bandLoops: {
			return "BandLoops";
		}
		case LCAppId.easyLoops: {
			return "EasyLoops";
		}
	}
}